import { Component } from '@headless-workspace/typings';
import styles from './loader.module.css';

// FIXME: To be replaced later with the one provided by the design
export const GlowLoader: Component = () => {
    return <div className={styles.ldsDualRing}></div>;
};
